/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NavItem } from '@src/app/model/sys/nav-item';
import { NavRoute } from '@src/app/shared/NavRoute';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDivider } from '@angular/material/divider';
import { TenantService } from '@src/app/shared/tenant.service';

@Component({
    selector: 'app-nav-item',
    templateUrl: './nav-item.component.html',
    styleUrls: ['./nav-item.component.scss'],
    imports: [MatExpansionModule, RouterLink, NgClass, MatIconModule, MatTooltipModule, MatDivider]
})

export class NavItemComponent {

    @Input() item: NavItem;
    @Input() showMenuText = true;
    @Input() asChild = false;
    @Input() selectedItem: NavItem;
    @Output() opened = new EventEmitter<NavItem>();
    @Output() selected = new EventEmitter<NavItem>();

    private tenantSvc = inject(TenantService);

    onOpen() {
        this.opened.emit(this.item);
    }

    selectOption(item: NavItem) {
        this.selected.emit(item);
    }

    selectChild(item: NavItem) { // Pass it up to parent
        this.selected.emit(item);
    }

    myTenantRouterLink(item: NavItem) {
        if (item.external) { // External site stuff!
            return item.url;
        }
        if (!item.url) {
            return null;
        }
        const url = `/${this.tenantSvc.getCurrentTenantId()}/${item.url}`;
        if (item.views?.length > 0) {
            return [url, { _view: item.views[0].id }];
        }
        return [url];
    }

    itemIcon(item: NavItem) {
        if (item.url && !item['open']) {
            const nr = NavRoute.getRoute(item.url);
            if (nr && nr.icon) {
                return nr.icon;
            }
        }
        if (item.icon) {
            return item.icon;
        }
        return '';
    }

}
